import React from 'react';
import PaginationBase from '../../../common/base/PaginationBase';
import { message } from 'antd';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import { SOLES } from '../../../common/types/monedaType';
import { OTROS, REQUERIMIENTO } from '../../../common/types/tipoComprobanteType';

import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';

import requerimientoService from '../../../service/logistica/requerimientoService';
import entidadService from '../../../service/administracion/entidadService';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModalVer from '../Requerimiento/FormModalVer';
import IngresoObservacionModal from './IngresoObservacionModal'
import ImprimirModal from '../Requerimiento/ImprimirModal';

var referenciaCount = 1;

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();

        this.state = {
            loadingSource: true,
            estadosRequerimiento: [],
            //monedas: [],
            //tiposCambioDiario: [],
            //listasPrecio: [],
            //establecimientos: [],
            //almacenes: [],
            //vendedores: [],
            //entidades: [],
            //direcciones: [],
            //tiposComprobante: [],
            //productos: [],
            //detracciones: [],
            entidades: [],
            estado:[],
            formValues: this.fetchEmptyFormValues(),
            filter: {
                fechaInicioStr: global.fetchCurrentDateStr(true),
                fechaFinStr: global.fetchCurrentDateStr(),
                documento: '',
                serie: '',
                idEstado:0,
                idEntidad:0,
                idTipoAntividad:0,
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            visibleVer: false,
            //productoVisible: false,
            //formValues: this.fetchEmptyFormValues(),
            //productoModal: {
            //    nombre: '',
            //    dataSource: [],
            //    selectedRowKeys: []
            //}
            imprimirFormValues: {
                file: undefined,
                idRequerimiento: 0
            },
            ingresoObservacionModal: {
                nombre: ''
            }
        }
    }

    async componentDidMount() {
        this._initPagination(this.state.filter, requerimientoService.paginacion);

        //const monedas = await monedaService.listar();
        //const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(global.fetchCurrentDateStr());
        //const listasPrecio = await listaPrecioService.listar();
        //const establecimientos = await establecimientoService.principales();
        //const vendedores = await vendedorService.listar();
        //const tiposComprobante = await tipoComprobanteService.listar();
        //const detracciones = await detraccionService.listar();
        //REGISTRADO, ANULADO, APROBADO, IMPORTADO, RECHAZADO
        const estado = await requerimientoService.listarEstado();

        const filterEntidad = {
            numeroDocumento: null,
            idTipoComprobante: OTROS.ID// FACTURA.ID
        }

        const entidades = await entidadService.obtenerTodos(filterEntidad);
        
        const estadosRequerimiento = [
            { id: 0, nombre: '- TODOS -' },
            { id: 1, nombre: 'REGISTRADO' },
            { id: 2, nombre: 'ANULADO' },
            { id: 3, nombre: 'APROBADO' },
            { id: 5, nombre: 'IMPORTADO' },
            { id: 4, nombre: 'RECHAZADO' }
        ];

        this.setState({
            loadingSource: false,
            filter: {
                ...this.state.filter,
                estadosRequerimiento: estadosRequerimiento
            },
            entidades: entidades ? entidades : [],
            estado: estado ? estado : [],
            
            //tiposCambioDiario: tiposCambioDiario ? tiposCambioDiario : [],
            //monedas: monedas ? monedas : [],
            //listasPrecio: listasPrecio ? listasPrecio : [],
            //establecimientos: establecimientos ? establecimientos : [],
            //vendedores: vendedores ? vendedores : [],
            //tiposComprobante: tiposComprobante ? tiposComprobante : [],
            //detracciones: detracciones ? detracciones : []
        });
    }

    handleKeyUpInput = (e) => {
        debugger
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleKeyUpInputSelect = (e) => {
        debugger
        //e.preventDefault();
        //if (e.keyCode === 13) {
        const filter = { ...this.state.filter, ...FILTER, idEstadoRequerimiento: e.key };
            this._handlePagination(filter);
        //}
    };

    handleClearFilters = () => {
        var filter = {
            fechaInicioStr: global.fetchCurrentDateStr(true),
            fechaFinStr: global.fetchCurrentDateStr(),
            documento: '',
            serie: '',
            idEstado: 0,
            idEntidad: 0,
            idTipoAntividad: 0,
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleChangeTab = (key) => {
        this.setState({
            formValues: {
                ...this.state.formValues,
                activeKey: key
            }
        });
    };

    handleVer = async (values) => {
        const response = await requerimientoService.obtenerPorId(values.id);
        if (response !== undefined) {
            var formValues = this.fetchEditFormValues(response);

            for (var i = 0; i < response.requerimientoDetalles.length; i++) {
                var item = response.requerimientoDetalles[i];
                var oneProd = {
                    //id: item.id,
                    idProducto: item.idProducto,
                    nombre: item.nombre,
                    cantidad: item.cantidad,
                    codigo: item.codigoReferencia,
                    nombreUnidadMedida: item.nombreUnidadMedida
                }
                formValues.listaComprobanteDetalle.push(oneProd);
            }

            for (var i = 0; i < response.requerimientoReferencias.length; i++) {
                referenciaCount = i + 1;
                var item = response.requerimientoReferencias[i];
                var oneRef = {
                    identifier: referenciaCount,
                    idReferencia: item.id,
                    idReferenciaOrigen: item.idReferenciaOrigen,
                    idTipoComprobante: item.idTipoComprobante,
                    serie: item.serie,
                    documento: item.documento,
                    flagInterno: true,
                    nombreTipoComprobante: item.nombreTipoComprobante
                }
                formValues.listaComprobanteReferencia.push(oneRef);
            }
            formValues.codigoTipo = response.requerimiento.idActividad;
            formValues.tipoCambio = response.requerimiento.tipoCambio;

            this.setState({
                visibleVer: true,
                formValues,
                //productoModal: {
                //    ...this.state.productoModal,
                //    selectedRowKeys: []
                //}
            });
        }
    }

    handleRechazar = async (values) => {
        dialog.confirm(`¿Desea rechazar el requerimiento ${values.serie}-${values.documento}?`, async () => {
            debugger
            const emptyForm = this.fetchEmptyFormValues();
            emptyForm.iD = values.id;
            this.setState({
                visible: true,
                formValues: emptyForm,
                ingresoObservacionModal: {
                    ...this.state.ingresoObservacionModal
                }
            });
        });
    }

    handleCompletarRechazo = async (values, form) => {
        var data = {
            idRequerimiento: values.id,
            codRequerimientoEstado: 'RE',
            observacionRechazado: values.observacionRechazo
        };
        console.log(data);
        var response = await requerimientoService.actualizarEstado(data);

        if (response.status === 200) {
            var empty = this.fetchEmptyFormValues();
            this.setState({ visible: false, formValues: empty });
            form.setFieldsValue(empty);
            form.resetFields();

            message.success('Registrado rechazado correctamente.');

            this._handlePagination(this.state.filter);
            return;
        }

        if (response.status === 400) {
            dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
            return;
        }
       
        dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        
    }

    handleAprobar = async (values) => {
        dialog.confirm(`¿Desea aprobar el requerimiento ${values.serie}-${values.documento}?`, async () => {
            debugger
            var data = {
                idRequerimiento: values.id,
                codRequerimientoEstado: 'AP'
            };
            var response = await requerimientoService.actualizarEstado(data);

            if (response.status === 200) {
                var empty = this.fetchEmptyFormValues();
                //this.setState({ visible: false, formValues: empty });
                //form.setFieldsValue(empty);
                //form.resetFields();

                message.success('Registrado aprobado correctamente.');

                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    }

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            //idTipoComprobante: FACTURA.ID,
            idEntidad: 0, //..........................................................OK
            idEstablecimientoEntidad: 0, //..........................................................OK
            //idProyecto: 0,
            //idVendedor: 0, //..........................................................OK
            //idAlmacen: 0, //..........................................................OK
            idMoneda: SOLES, //..........................................................OK
            idListaPrecio: 0, //..........................................................OK
            //idComprobanteEstado: 0,
            //idEstablecimiento: 0, //..........................................................OK
            //idDetraccion: 0, //..........................................................OK
            //idUsuarioRegistro: 0,
            serie: "", //............................................... OK
            documento: "", //............................................... OK
            fechaStr: global.fetchCurrentDateStr(), //......................................... OK
            fechaVencimientoStr: global.fetchCurrentDateStr(), //......................................... OK
            diasVencimiento: 0, //..........................................................OK
            //numeroPlaca: "", //..........................................................OK
            //tipoCambio: 0, //..........................................................OK
            observacion: "", //..........................................................OK
            //flagExportacion: false, //..........................................................OK
            //flagPercepcion: false, //..........................................................OK
            //flagDetraccion: false, //..........................................................OK
            //flagAnticipo: true,
            //flagGrifo: true,
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            /*********************/
            //sumaTotalDetalle: 0,
            //sumaImporteDescuento: 0,
            //sumaSubTotal: 0,
            //sumaIgv: 0,
            //sumaIsc: 0,
            //sumaTotal: 0,
            //porcentajeDetraccion: 0,
            //importeDetraccion: 0,
            //totalDetraccion: 0,
            //porcentajePercepcion: 0,
            //importePercepcion: 0,
            //totalPercepcion: 0,
            //totalDetailDisabled: auth.user().parametros.filter(m => m.abreviatura === VENTA_MODIFICAR_TOTAL_PRODUCTO)[0].valor === "1" ? false : true,
            //flagEmpresaGrifo: auth.user().parametros.filter(m => m.abreviatura === EMPRESA_GRIFO)[0].valor === "1" ? true : false,
            //almacenLoading: false,
            entidadLoading: false,
            activeKey: "1",
            documentoEntidad: "",
            //monedas: [],
            //tiposCambioDiario: [],
            listasPrecio: [],
            //establecimientos: [],
            //almacenes: [],
            //vendedores: [],
            entidades: [],
            direcciones: [],
            tiposComprobante: [],
            //detracciones: []
        }
    };

    fetchEditFormValues = (value) => {

        return {
            id: value.requerimiento.iD,
            //idTipoComprobante: FACTURA.ID,
            idEntidad: value.requerimiento.idEntidad, //..........................................................OK
            documentoEntidad: value.requerimiento.documentoEntidad,
            idEstablecimientoEntidad: value.requerimiento.idEstablecimiento, //..........................................................OK
            //idProyecto: 0,
            //idVendedor: 0, //..........................................................OK
            //idAlmacen: 0, //..........................................................OK
            idMoneda: SOLES, //..........................................................OK
            idListaPrecio: 0, //..........................................................OK
            //idComprobanteEstado: 0,
            //idEstablecimiento: 0, //..........................................................OK
            //idDetraccion: 0, //..........................................................OK
            //idUsuarioRegistro: 0,
            serie: value.requerimiento.serie, //............................................... OK
            documento: value.requerimiento.documento, //............................................... OK
            fechaStr: value.requerimiento.fechaStr, //global.fetchCurrentDateStr(), //......................................... OK
            fechaVencimientoStr: value.requerimiento.fechaVencimientoStr, //......................................... OK
            diasVencimiento: value.requerimiento.diasVencimiento, //..........................................................OK
            codigoTipo: 0, //..........................................................OK
            tipoCambio: value==undefined ? 0:value.requerimiento.tipoCambio, //..........................................................OK
          
            //numeroPlaca: "", //..........................................................OK
            //tipoCambio: 0, //..........................................................OK
            observacion: value.requerimiento.observacion, //..........................................................OK
            //flagExportacion: false, //..........................................................OK
            //flagPercepcion: false, //..........................................................OK
            //flagDetraccion: false, //..........................................................OK
            //flagAnticipo: true,
            //flagGrifo: true,
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            /*********************/
            //sumaTotalDetalle: 0,
            //sumaImporteDescuento: 0,
            //sumaSubTotal: 0,
            //sumaIgv: 0,
            //sumaIsc: 0,
            //sumaTotal: 0,
            //porcentajeDetraccion: 0,
            //importeDetraccion: 0,
            //totalDetraccion: 0,
            //porcentajePercepcion: 0,
            //importePercepcion: 0,
            //totalPercepcion: 0,
            //totalDetailDisabled: auth.user().parametros.filter(m => m.abreviatura === VENTA_MODIFICAR_TOTAL_PRODUCTO)[0].valor === "1" ? false : true,
            //flagEmpresaGrifo: auth.user().parametros.filter(m => m.abreviatura === EMPRESA_GRIFO)[0].valor === "1" ? true : false,
            //almacenLoading: false,
            entidadLoading: false,
            activeKey: "1",
            documentoEntidad: value.requerimiento.documentoEntidad,
            //monedas: [],
            //tiposCambioDiario: [],
            listasPrecio: [],
            //establecimientos: [],
            //almacenes: [],
            //vendedores: [],
            entidades: [],
            direcciones: [],
            tiposComprobante: [],

            documentoEntidad: value.requerimiento.documentoEntidad,
            razonSocialEntidad: value.requerimiento.razonSocialEntidad,
            tipoDocumentoEntidad: value.requerimiento.tipoDocumentoEntidad,
            entidad: value.requerimiento.entidad,
            direccionEntidad: value.requerimiento.direccionEntidad,
            nombreProyecto: value.requerimiento.nombreProyecto
            //detracciones: []
        }
    }

    handleImprimir = async (item) => {
        
        var file = undefined;
        var response = await requerimientoService.pdfA4({ id: item.id });
        file = window.URL.createObjectURL(response.data);

        this.setState({
            imprimirVisible: true,
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                file,
                idRequerimiento: item.id
            }
        });
    };

    handleExportExcel = async () => {
        var response = await requerimientoService.excel(this.state.filter);
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Requerimientos.xlsx");
    }

    render() {
        return (
            <div>
                <Header
                    title="Bandeja de Requerimiento"
                    //onNew={this.handleNew}
                    onSearch={() => this._handlePagination(this.state.filter)}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    estado={this.state.estado}
                    entidades={this.state.entidades}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onKeyUpSearchSelect={this.handleKeyUpInputSelect}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingEdit={this.state.loadingSource}
                    onExportExcel={this.handleExportExcel}
                    onImprimir={this.handleImprimir}
                    onChange={this._handleChangePagination}
                    onVer={this.handleVer}
                    onRechazar={this.handleRechazar}
                    onAprobar={this.handleAprobar}
                />
                <FormModalVer
                    visible={this.state.visibleVer}
                    formValues={this.state.formValues}
                    onChangeTab={this.handleChangeTab}
                    onClose={() => this.setState({ visibleVer: false })}
                />
                <IngresoObservacionModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleCompletarRechazo}
                />
                   <ImprimirModal
                    visible={this.state.imprimirVisible}
                    formValues={this.state.imprimirFormValues}
                    onChange={this.handleChangeImprimir}
                    onClose={() => this.setState({ imprimirVisible: false })}
                />
            </div>
        );
    }

}